import { doHttp } from '../utils/common'
import { HTTP_TYPE_POST, HTTP_TYPE_GET } from '../utils/config'

/**
 * 新增/修改
 * @param params
 * @return {*}
 */
export function apiEdit (params) {
  return doHttp('/advertisement/addOrUpdate.action', HTTP_TYPE_POST, params)
}

/**
 * 删除
 * @param id
 * @return {*}
 */
export function apiDelete (id) {
  let params = { id }
  return doHttp('/advertisement/delete.action', HTTP_TYPE_GET, params)
}

/**
 * 详情
 * @param id
 * @return {*}
 */
export function apiDetail (id) {
  let params = { id }
  return doHttp('/advertisement/detail.action', HTTP_TYPE_GET, params)
}

/**
 * 列表
 * @param params
 * @param status
 * @param pageIndex
 * @param pageSize
 * @return {*}
 */
export function apiGetList (params, status, pageIndex = 1, pageSize = 20) {
  return doHttp(`/advertisement/list.action?status=${status}&pageIndex=${pageIndex}&pageSize=${pageSize}`, HTTP_TYPE_POST, params)
}

/**
 * 上架/下架
 * @param id
 * @return {*}
 */
export function apiSwitch (id) {
  let params = { id }
  return doHttp('/advertisement/upOrDown.action', HTTP_TYPE_GET, params)
}
